import modal from '../../smartpak/modal.js';
import { getUserLocation } from '../../vendor/dynamicyield/dynamicyield.js';

function remove(selector) {
    Array.from(document.querySelectorAll(selector)).forEach($element => {
        if ($element) {
            $element.parentElement.removeChild($element);
        }
    });
}

function html(selector, content) {
    Array.from(document.querySelectorAll(selector)).forEach(element => (element.innerHTML = content));
}

const zipCode = {
    init: function (initialUserLocation, isMobile) {
        this._isMobile = isMobile;

        if (this._isMobile) {
            remove('noindex .header3plMsg');
            remove('noindex .shipOpt');
            remove('.hideAspx');
        }

        getUserLocation().then(userLocation => this._onUserLocation({ pathname: location.pathname, geoFields: userLocation, isMobile }));

        this._onApiSuccess(initialUserLocation);
        this._bindUIEvents();
        this._initialTimeSet('', this._getPreferredDeadline(initialUserLocation.cutOffTime));
    },

    _onUserLocation: function (data) {
        if (this._shouldHideETABanner(data)) {
            remove('#eta-ribbon-message');
        }
    },

    _shouldHideETABanner: function ({ pathname, geoFields }) {
        return /cart|checkout/gi.test(pathname) || /alaska|hawaii/gi.test(geoFields?.state);
    },

    _bindUIEvents: function () {
        const trigger = document.querySelector('.preferredZipCode'),
            shipPolicyTrigger = Array.from(document.querySelectorAll('.preferredShip'));

        if (trigger) {
            trigger.addEventListener('click', e => {
                e.preventDefault();
                this._getPreferredZipCodeView();
            });
        }

        shipPolicyTrigger.forEach(element => {
            element.addEventListener('click', event => {
                event.preventDefault();
                this._showShipPolicyModal(event.target.dataset.modalWidth);
            });
        });
    },

    _showShipPolicyModal: function (width) {
        modal(document.querySelector('.shipOpt'), {
            title: 'Shipping Policy',
            width: width
        });
    },

    _getPreferredZipCodeView: function () {
        import('./zipcodeform.js').then(({ default: zipCodeForm }) => {
            zipCodeForm(this._isMobile, this._onApiSuccess.bind(this));
        });
    },

    _getDaylightSavingsTime: function () {
        var today = new Date(),
            jan = new Date(today.getFullYear(), 0, 1),
            jul = new Date(today.getFullYear(), 6, 1),
            monthDiff = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset()),
            dst = today.getTimezoneOffset() < monthDiff;

        return dst;
    },

    _getPreferredDeadline: function (cutoff) {
        var currentDate = new Date(),
            month = currentDate.getMonth() + 1,
            day = currentDate.getDate(),
            output =
                (month < 10 ? '0' : '') + month + '/' + (day < 10 ? '0' : '') + day + '/' + currentDate.getFullYear(),
            offset = '5',
            deadline;

        if (this._getDaylightSavingsTime()) {
            offset = '4';
        }

        deadline = output + ' ' + cutoff + ':00:00 GMT-0' + offset + '00';

        return deadline;
    },

    _onApiSuccess: function (initialUserLocation) {
        html('.preferredCityState', initialUserLocation.city + ', ' + initialUserLocation.state);
        html('.preferredDate', '<span id="loadPreferredDate">' + initialUserLocation.deliveryBy + '</span>');

        this._initializeClock(this._getPreferredDeadline(initialUserLocation.cutOffTime));

        if (initialUserLocation.zipCode !== smartPak.preferredLocationCookie.PreferredZipCode) {
            smartPak.preferredLocationCookie.refreshCookieData();

            if (smartPak.productClassViewModel && smartPak.productClassViewModel.updateEstimatedArrivalDates) {
                smartPak.productClassViewModel.updateEstimatedArrivalDates();
            }
        }
    },

    _getTimeRemaining: function (endtime) {
        var end = new Date(endtime),
            today = new Date(),
            t = end - today,
            minutes,
            hours;

        if (t <= 0) {
            end.setDate(end.getDate() + 1);
            t = new Date(end) - today;
        }

        minutes = Math.floor((t / 1000 / 60) % 60);
        hours = Math.floor((t / (1000 * 60 * 60)) % 24);

        return {
            total: t,
            hours: hours,
            minutes: minutes
        };
    },

    _initialTimeSet: function (interval, endtime) {
        var t = this._getTimeRemaining(endtime),
            $noTime = $('.noTime'),
            $perferredTime = $('.preferredTime');

        $perferredTime.html(t.hours + ' hrs ' + t.minutes + ' mins');

        if (t.hours === 0 && t.minutes === 0) {
            $noTime.html('now');
            $perferredTime.hide();

            clearTimeout(interval);
             
            interval = null;
        } else {
            $noTime.html('within');
            $perferredTime.show();
        }
    },

    _initializeClock: function (endtime) {
        var TIMEOUT_MS = 60000,
            timeinterval,
            handleInterval = () => {
                requestAnimationFrame(
                    function () {
                        this._initialTimeSet(timeinterval, endtime);
                    }.bind(this)
                );
            },
            $header3plMsg = document.querySelector('noindex .header3plMsg.jsHide');

        if (this._isMobile && $header3plMsg) {
            $header3plMsg.classList.add('jsHide');
        }

        Array.from(document.querySelectorAll('.preferredShip, .preferredZipCode')).forEach(element =>
            element.classList.remove('jsHide')
        );

        timeinterval = setInterval(handleInterval, TIMEOUT_MS);
    }
};

export default zipCode;
